import { JobCategory } from '@/modules/JobCategory/types'
import dayjs from 'dayjs'
import { Typogaphy } from 'vnetwork-ui'
import { GridColDefVNW } from 'vnetwork-ui/dist/components/DataGridPro'

export const JobCategoryColumns: GridColDefVNW<JobCategory>[] = [
    {
        field: 'id',
        headerName: 'id',
        width: 100,
    },
    {
        field: 'title',
        headerName: 'job-category-title',
        width: 200,
    },
    {
        field: 'description',
        headerName: 'job-category-description',
        width: 500,
    },
    {
        field: 'created_at',
        headerName: 'job-category-created-at',
        width: 250,
        renderCell: ({ row }) => (
            <Typogaphy size="small">
                {row?.created_at
                    ? dayjs(row.created_at).format('DD/MM/YYYY HH:mm')
                    : ''}
            </Typogaphy>
        ),
    },
    {
        field: 'updated_at',
        headerName: 'job-category-updated-at',
        width: 250,
        renderCell: ({ row }) => (
            <Typogaphy size="small">
                {row?.updated_at
                    ? dayjs(row.updated_at).format('DD/MM/YYYY HH:mm')
                    : ''}
            </Typogaphy>
        ),
    },
]
